import { initTealiumListeners } from './trackTealium';

export function initLegacyAffiliateListener({ $bus, appOptions }) {
  initTealiumListeners({ $bus, loggerLevel: appOptions.loggerLevel });
}
